export class ErrorWithDetails extends Error {
  details = '';
  actionUrl;
  actionLabel;

  constructor(
    message: string,
    details: string,
    actionUrl?: string,
    actionLabel?: string
  ) {
    super(message as string);
    this.details = details;
    this.name = ErrorWithDetails.name;
    this.actionUrl = actionUrl;
    this.actionLabel = actionLabel;
  }
}

export class ErrorWithNodeData extends Error {
  nodeId;
  nodeName;

  constructor(message: string, nodeId?: string, nodeName?: string) {
    super(message);
    this.nodeId = nodeId;
    this.nodeName = nodeName;
    this.name = ErrorWithNodeData.name;
  }
}
